/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class StudyTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studyType: this.props.studyType,
      style: null,
      studyTypeList: [
        {type: '내신', text: '내신 (중/고생)'},
        {type: '입시', text: '입시 (고3/N수)'},
        {type: '취업관련', text: '취업관련'},
        {type: '공무원', text: '공무원'},
        {type: '자격증', text: '자격증'},
        {type: '어학', text: '어학'},
        {type: '고시', text: '고시'},
        {type: '자기계발', text: '자기계발'},
        {type: '기타', text: '기타'}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeStudyTypeEvent = (e) => {
    this.setState({ studyType: e.target.dataset.studytype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="studygoal-pop" style={this.state.style} ref={ref => this.layer = ref}>	
        <div className="bg" data-studytype={this.state.studyType} data-type="studyType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.studyTypeList.map((entity, index) => <li key={index} className={this.state.studyType === entity.type ? 'active' : ''}><a href={null} data-studytype={entity.type} onClick={this._doChangeStudyTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default StudyTypePop;